import { render, staticRenderFns } from "./PaymentBillEfectyBaloto.vue?vue&type=template&id=5498ac30&"
import script from "./PaymentBillEfectyBaloto.vue?vue&type=script&lang=js&"
export * from "./PaymentBillEfectyBaloto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports